import {Row, Statistic} from 'antd';
import useCommon from '@utils/hooks/common';
import userIconFrame from '@public/images-mobile/game-room/my_icon.svg';
import Icon from '@ant-design/icons';
import styles from './styles';
import PlayerAvatar from '@components/PlayerAvatar';
import {PLAYER_ROLE, PLAYER_ACTION} from '@constant/game';
import {compactFormatter} from '@utils/index';

interface PlayerInfoInterface {
  playerName?: string;
  playerRole?: string;
  playerAction?: string;
  isAllIn?: boolean;
  // eslint-disable-next-line react/no-unused-prop-types
  containerWidthPx?: number;
  icon?: string;
  actionsAmount?: number;
  prefix?: string;
  suffix?: string;
}

const PlayerInfo = (props: PlayerInfoInterface) => {
  const {classes, t, language} = useCommon({
    withTranslation: ['playerInfo'],
    withStyles: {styles, hasProps: true, props},
  });
  const {
    containerWidthPx,
    playerName: userName,
    playerRole: role,
    playerAction: action,
    isAllIn,
    icon,
    actionsAmount,
    prefix,
    suffix,
  } = props;
  const avatarToContainerRatio = 0.6;

  const getPlayerRole = (roleLocal: string): string => {
    if (roleLocal === PLAYER_ROLE.BUTTON) return t('button');
    if (roleLocal === PLAYER_ROLE.SMALL_BLIND) return t('smallBlind');
    if (roleLocal === PLAYER_ROLE.BIG_BLIND) return t('bigBlind');

    return role;
  };

  const SKIP_ACTION = 'SKIP';

  const getPlayerAction = (actionLocal: string, isAllInLocal?: boolean): string => {
    if (isAllInLocal) return t('allIn');
    if (actionLocal === PLAYER_ACTION.BET) return t('bet');
    if (actionLocal === PLAYER_ACTION.CHECK) return t('check');
    if (actionLocal === PLAYER_ACTION.CALL) return t('call');
    if (actionLocal === PLAYER_ACTION.RAISE) return t('raise');
    if (actionLocal === PLAYER_ACTION.FOLD) return t('fold');
    if (actionLocal === PLAYER_ACTION.CANCEL_INSURANCE) return t('cancelInsurance');
    if (actionLocal === PLAYER_ACTION.CONFIRM_INSURANCE) return t('confirmInsurance');
    if (actionLocal === PLAYER_ACTION.ALL_IN) return t('allIn');
    if (actionLocal === SKIP_ACTION) return t('skip');

    return actionLocal;
  };

  return (
    <div className={classes.container}>
      <div className={classes.playerInfoColumn}>
        {/* <div className={classes.IconAndNameColumn}>
          <PlayerAvatar icon={null} iconWidthPx={containerWidthPx * avatarToContainerRatio || 40} /> */}
        {/* no role if player exits */}
        {/* {role && <div className={classes.role}>{role}</div>}
        </div>
        <div className={classes.actionColumn}>
          <div className={classes.userName}>{userName}</div>
          <Row className={classes.actionBox}> */}
        <div className={classes.iconAndNameColumn}>
          <div className={classes.iconAndNameContainer}>
            <PlayerAvatar icon={icon} iconWidthPx={30} />
            <div className={classes.role}>{getPlayerRole(role)}</div>
          </div>
        </div>
        <div className={classes.actionColumn}>
          <div className={classes.userName}>{userName}</div>
          <Row>
            {action && (
              <>
                <div className={classes.triangle} />
                <div className={classes.actionBox}>
                  <div className={classes.actionSpan}>{getPlayerAction(action, isAllIn)}</div>

                  {actionsAmount !== 0 && (
                    <div className={classes.actionAmountSpan}>
                      <Statistic
                        value={actionsAmount}
                        prefix={prefix}
                        suffix={suffix}
                        valueStyle={{
                          fontSize: '9px',
                          lineHeight: '105%',
                          color: 'black',
                        }}
                        precision={0}
                        formatter={compactFormatter}
                      />
                    </div>
                  )}

                  {/* <MultiUnitStatistic value={actionsAmount} style={{fontSize: 9}} /> */}
                </div>
              </>
            )}
          </Row>
        </div>
      </div>
    </div>
  );
};

export default PlayerInfo;
